import { registerPlugin } from '@capacitor/core';
import { DeviceFileSystemPlugin } from '@/native/plugins/DeviceFileSystem/definitions';

const DeviceFileSystem = registerPlugin<DeviceFileSystemPlugin>(
  'DeviceFileSystem',
  {
    web: () => import('./web').then((m) => new m.DeviceFileSystemWeb()),
  }
);

export * from './definitions';
export { DeviceFileSystem };
